import { render, staticRenderFns } from "./playerControlPie.vue?vue&type=template&id=2837db66&scoped=true"
import script from "./playerControlPie.vue?vue&type=script&lang=js"
export * from "./playerControlPie.vue?vue&type=script&lang=js"
import style0 from "./playerControlPie.vue?vue&type=style&index=0&id=2837db66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837db66",
  null
  
)

export default component.exports